import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";

const fetchApplicantView = async (data) => {
  const orderByParam =
    data?.orderBy !== undefined ? `OrderBy=${data?.orderBy}` : "FirstName";
  const orderDirParam =
    data?.orderDir !== undefined ? `orderDir=${data?.orderDir}` : "asc";
  const fieldOfInterestParam =
    data?.FieldOfInterest !== undefined
      ? `FieldOfInterest=${data?.FieldOfInterest}`
      : "";
  const statusParam =
    data?.status !== undefined ? `status=${data?.status}` : "";
  const programParam =
    data?.program !== undefined ? `program=${data?.program}` : "";
  const searchParam =
    data?.search !== undefined ? `SearchBy=${data?.search}` : "";

  return await axios.get(
    API_URL +
      `/api/ApplicantView/GetApplicants/${data?.pageSize}/${data?.pageNumber}?${orderByParam}&${orderDirParam}&${fieldOfInterestParam}&${statusParam}&${programParam}&${searchParam}`,
    {
      headers: securityHeaders,
    }
  );
};

export const useFetchApplicantView = (data) => {
  return useQuery({
    queryKey: ["Applicant"],
    queryFn: () => fetchApplicantView(data),
    enabled: true,
  });
};

/****************fetch single applicant */
const fetchSingleApplicant = async (id) => {
  if (id) {
    return await axios.get(
      API_URL + `/api/ApplicantView/GetApplicantById?ApplicantId=${id}`,
      {
        headers: securityHeaders,
      }
    );
  }
};
export const useFetchSingleApplicant = (id) => {
  return useQuery({
    queryKey: ["ApplicantById"],
    queryFn: () => fetchSingleApplicant(id),
    enabled: true,
  });
};

/***************Update applicant status */

const changeApplicantStatus = (fields) => {
  return axios.post(
    API_URL + `/api/ApplicantView/ChangeApplicantStatus`,
    fields,
    {
      headers: securityHeaders,
    }
  );
};

export const useChangeApplicantsStatus = () => {
  return useMutation(changeApplicantStatus);
};

/*******************Get applicant status */
const fetchApplicantStatus = async () => {
  return await axios.get(API_URL + "/api/ApplicantView/GetApplicantStatuses", {
    headers: securityHeaders,
  });
};
export const useFetchApplicantStatus = () => {
  return useQuery({
    queryKey: ["applicantStatus"],
    queryFn: () => fetchApplicantStatus(),
    enabled: true,
  });
};

//*********export applicants table */
const exportApplicants = async () => {
  return await axios.get(API_URL + "/api/Export/ExportApplicants", {
    headers: securityHeaders,
    responseType: "blob",
  });
};
export const useExportApplicantsTable = () => {
  return useMutation(() => exportApplicants());
};
